import { FC, MouseEvent, useCallback, useState } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { useFragment } from 'react-relay';
import FileSaver from 'file-saver';

import DownloadIcon from '@mui/icons-material/Download';
import Link from '@mui/material/Link';
import Divider from '@mui/material/Divider';
import SidebarBox from 'components/SidebarBox';

import { API } from 'const';
import { ContractDownloadBox_order$key } from '__generated__/ContractDownloadBox_order.graphql';
import { useNotification } from 'components/Notifications';

type Props = {
  order: ContractDownloadBox_order$key;
};

const ContractDownloadBox: FC<Props> = ({ order }) => {
  const [loading, setLoading] = useState(false);
  const { pop } = useNotification();

  const { uuid, orderNr } = useFragment(
    graphql`
      fragment ContractDownloadBox_order on Order {
        uuid
        orderNr
      }
    `,
    order
  );

  const handleContractDownload = useCallback(
    (event: MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();

      const options = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };

      setLoading(true);

      fetch(event.currentTarget.href, options)
        .then(res => res.blob())
        .then(blob => {
          setLoading(false);
          FileSaver.saveAs(blob, `tedo-sutartis-${orderNr}.pdf`);
        })
        .catch(error => {
          setLoading(false);
          pop('Klaida');
        });
    },
    [orderNr, pop]
  );

  if (!orderNr) return null;

  return (
    <>
      <SidebarBox icon={DownloadIcon} loading={loading}>
        <Link
          href={`${API}/orders/${uuid}/contract`}
          onClick={handleContractDownload}>
          Kliento sutartis
        </Link>
      </SidebarBox>

      <Divider />
    </>
  );
};

export default ContractDownloadBox;
